export const didPresenters = [
  {
    id: 'v2_public_Amber_RedSweater_HomeOffice@atjDiWT4JK',
    name: 'Amber Red Sweater',
    location: 'Home Office'
  },
  {
    id: 'v2_public_Alice_Office@atjDiWT4JK',
    name: 'Alice Office',
    location: 'Office'
  },
  {
    id: 'v2_public_Andrew_Casual_HomeOffice@atjDiWT4JK',
    name: 'Andrew Casual',
    location: 'Home Office'
  },
  {
    id: 'v2_public_Ariana_Business_Studio@atjDiWT4JK',
    name: 'Ariana Business',
    location: 'Studio'
  },
  {
    id: 'v2_public_Matt_Business_Studio@atjDiWT4JK',
    name: 'Matt Business',
    location: 'Studio'
  },
  {
    id: 'v2_public_Jack_Casual_Studio@atjDiWT4JK',
    name: 'Jack Casual',
    location: 'Studio'
  },
  {
    id: 'v2_public_James_Business_Office@atjDiWT4JK',
    name: 'James Business',
    location: 'Office'
  },
  {
    id: 'v2_public_Jane_Business_Office@atjDiWT4JK',
    name: 'Jane Business',
    location: 'Office'
  },
  {
    id: 'v2_public_Jason_BlueShirt_HomeOffice@atjDiWT4JK',
    name: 'Jason Blue Shirt',
    location: 'Home Office'
  },
  {
    id: 'v2_public_Joanna_GreenJacket_HomeOffice@atjDiWT4JK',
    name: 'Joanna Green Jacket',
    location: 'Home Office'
  },
  {
    id: 'v2_public_Maya_Casual_CoWorking@atjDiWT4JK',
    name: 'Maya Casual',
    location: 'Co Working'
  },
  {
    id: 'v2_public_Michael_ModernOffice@atjDiWT4JK',
    name: 'Michael Modern Office',
    location: 'Office'
  },
  {
    id: 'v2_public_Nicole_BlueBlazer_Studio@atjDiWT4JK',
    name: 'Nicole Blue Blazer',
    location: 'Studio'
  },
  {
    id: 'v2_public_Olivia_Studio@atjDiWT4JK',
    name: 'Olivia Studio',
    location: 'Studio'
  },
  {
    id: 'v2_public_Robert_CoWorking@atjDiWT4JK',
    name: 'Robert Co Working',
    location: 'Co Working'
  },
  {
    id: 'v2_public_Sophia_Casual_Studio@atjDiWT4JK',
    name: 'Sophia Casual',
    location: 'Studio'
  },
  {
    id: 'v2_public_Thomas_Executive_Office@atjDiWT4JK',
    name: 'Thomas Executive',
    location: 'Office'
  },
  {
    id: 'v2_public_Victoria_Studio@atjDiWT4JK',
    name: 'Victoria Studio',
    location: 'Studio'
  }
];

